import { IDashboardMessage } from "../Models/Models";

const getDomain = (): string => {
    const { hostname, port, protocol } = window.location;
    return hostname === 'localhost'
        ? `${protocol}//${hostname}:${port}`
        : `https://${hostname}`;
};

export const sendDashBoardMessage = (message: IDashboardMessage): void => {
    const domain = getDomain();
    const messageWindow = (document.getElementById(message.targetElement) as HTMLIFrameElement).contentWindow;
    
    messageWindow.postMessage(message, domain);
};

export const receiveDashBoardMessage = (element: string): void => {
    const iframe = document.getElementById(element) as HTMLIFrameElement;
    if (iframe) {
        const listener = iframe.contentWindow;

        listener.addEventListener(
            "message",
            (event) => {
                const domain = getDomain();
                if (event.origin !== domain) {
                    return;
                }

                const message = event.data.message;
                if (message && message.text === "TWO_BY_TWO") {
                    $("#experimental-scout").hide();
                    const name = message.data.name.replace(/ /g, "!");
                    location.assign(`#/network/:${message.data.sid}:${name}`);
                }
            },
            false
        );
    }
};
